export const VocabCalendarWidget = {
  header_title: ["Agenda & Citas", "Schedule & Appointments"],
  no_profile_selected: [
    "Selecciona un médico para ver su disponibilidad.",
    "Select a doctor to view their availability.",
  ],
  prev_button: ["Anterior", "Prev"],
  next_button: ["Siguiente", "Next"],
  unauthenticated_notice: [
    "Inicia sesión para ver horarios disponibles y agendar una cita.",
    "Log in to view available time slots and book an appointment.",
  ],
  loading_schedule: [
    "Cargando disponibilidad...",
    "Loading availability...",
  ],
  fetch_error: [
    "No se pudo cargar la agenda.",
    "Could not load schedule.",
  ],
  no_slots_this_week: [
    "No hay horarios disponibles para esta semana.",
    "No available time slots for this week.",
  ],
};

export type VocabCalendarWidgetKey = keyof typeof VocabCalendarWidget;
export default VocabCalendarWidget;